import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { ToastContainerComponent } from '../../../shared/components/toast-container/toast-container.component';
import { environment } from '../../../../environments/environment';
import { formatPhoneNumber } from '../../../shared/utils/format.utils';
import { LEGAL_URLS } from '../../../shared/constants/legal-urls';

/**
 * Main Layout Component
 * Wraps the entire application with sidebar and topbar navigation
 * Based on dashboard mockups in agent-os/design/mockups/web-portal/
 */
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, SidebarComponent, TopbarComponent, ToastContainerComponent],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  sidebarCollapsed: boolean = true; // Start collapsed on mobile

  // Technical support phone number from environment
  technicalSupportPhone = environment.technicalSupportPhone;
  formattedSupportPhone = formatPhoneNumber(environment.technicalSupportPhone);

  // Footer meta (moved out of the sidebar)
  readonly legalUrls = LEGAL_URLS;
  appVersion = environment.version;

  /**
   * Toggle sidebar collapsed state
   */
  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  /**
   * Close sidebar when clicking on overlay (mobile only)
   */
  @HostListener('click', ['$event'])
  onLayoutClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // Check if click is on the overlay (app-layout but not sidebar or its children)
    if (target.classList.contains('app-layout') && !this.sidebarCollapsed) {
      this.sidebarCollapsed = true;
    }
  }
}
